import React from "react";
import { Box, TextField, MenuItem } from "@mui/material";

const COUNTRY_CODES = [
  { code: "+91",  name: "India" },
  { code: "+1",   name: "US / Canada" },
  { code: "+44",  name: "United Kingdom" },
  { code: "+971", name: "UAE" },
  { code: "+65",  name: "Singapore" },
  { code: "+60",  name: "Malaysia" },
  { code: "+61",  name: "Australia" },
  { code: "+81",  name: "Japan" },
  { code: "+49",  name: "Germany" },
  { code: "+33",  name: "France" },
];

// Sort longest-first so "+971" matches before "+1" etc.
const CODES_BY_LENGTH = [...COUNTRY_CODES].sort((a, b) => b.code.length - a.code.length);

export const parsePhoneNumber = (raw) => {
  if (!raw) return { countryCode: "+91", phoneNo: "" };
  const s = String(raw).trim();
  for (const { code } of CODES_BY_LENGTH) {
    if (s.startsWith(code)) {
      return { countryCode: code, phoneNo: s.slice(code.length) };
    }
  }
  return { countryCode: "+91", phoneNo: s };
};

const PhoneInput = ({
  countryCode,
  phoneNo,
  onCountryCodeChange,
  onPhoneNoChange,
  label = "Phone Number",
  required = false,
  fullWidth = false,
  error = false,
  helperText = "",
}) => (
  <Box display="flex" gap={1} sx={{ width: fullWidth ? "100%" : undefined }}>
    <TextField
      select
      value={countryCode}
      onChange={(e) => onCountryCodeChange(e.target.value)}
      SelectProps={{
        renderValue: (v) => v,
        MenuProps: { PaperProps: { sx: { maxHeight: 300 } } },
      }}
      sx={{ width: 90 }}
    >
      {COUNTRY_CODES.map(({ code, name }) => (
        <MenuItem key={code} value={code}>
          <Box component="span" sx={{ fontWeight: 600, mr: 1 }}>{code}</Box>
          <Box component="span" sx={{ color: "text.secondary", fontSize: "0.875rem" }}>{name}</Box>
        </MenuItem>
      ))}
    </TextField>
    <TextField
      label={label}
      value={phoneNo}
      onChange={(e) => onPhoneNoChange(e.target.value)}
      required={required}
      error={error}
      helperText={helperText}
      sx={{ flex: 1 }}
    />
  </Box>
);

export default PhoneInput;
